const destinationChargeType = {
  POINT: 'point',
  CITY: 'city',
  REGION: 'region',
  STATE: 'state',
  PINCODE: 'pincode',
};

const chargeCode = {
  ODA: 'oda',
  DROP_POINT: 'drop_point',
  UNLOADING: 'unloading',
  EXTRA_DROP_OFF: 'extra_drop_off',
  MALL_CHARGE: 'mall_charge',
  APPOINTMENT_CHARGE: 'appointment_charge',
  ECC: 'ecc',
};

const sourceChargeCode = {
  ADDITIONAL_PICKUP: 'additional_pickup',
};

const defaultMovement = 'default';

module.exports = {
  destinationChargeType,
  chargeCode,
  defaultMovement,
  sourceChargeCode,
};
